module.exports = __webpack_public_path__ + "static/scholarshipRight-bbf02d2b52a87ea5a9b5b185e04168b3.svg";